import React from 'react';

// Import all components
// const PageBlog = React.lazy(() => import('./pages/PageBlog'));
// const PageBlogDetail = React.lazy(() => import('./pages/PageBlogDetail'));
// const PageBlogSidebar = React.lazy(() => import('./pages/PageBlogSidebar'));
const PageContact = React.lazy(() => import('./pages/PageContact'));
const PageJobDetail = React.lazy(() => import('./pages/PageJobDetail'));
const PageTeam = React.lazy(() => import('./pages/PageTeam'));
const PageWork = React.lazy(() => import('./pages/PageWork'));
const PageWorkDetail = React.lazy(() => import('./pages/PageWorkDetail'));
const Hotc = React.lazy(() => import('./pages/Hotc'));

const routes = [
	// public Routes
	{ path: '/hotc', component: Hotc },
	{ path: '/event/:urlSlug', component: PageWorkDetail },
	{ path: '/contact', component: PageContact },
	{ path: '/apply', component: PageJobDetail },
	{ path: '/team', component: PageTeam },
	{ path: '/events', component: PageWork }
	// { path: '/page-blog', component: PageBlog },
	// { path: '/page-blog-detail', component: PageBlogDetail },
	// { path: '/page-blog-sidebar', component: PageBlogSidebar },
];

export default routes;
